module.exports = __webpack_public_path__ + "img/B2cEurope.e6d540b4.png";